// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__i-LwN","choiceBoxes":"toolbarselects_choiceBoxes__1RkfI","simpleField":"toolbarselects_simpleField__3BbQ4"};